import React, { createContext, useContext } from "react";
import noop from "lodash/noop";
import type { SearchValues } from "../types/aml.type";

type LastSearch = SearchValues | undefined;

interface AmlSearchContextValue {
  lastSearch: LastSearch;
  setLastSearch: (_values: LastSearch) => void;
}

const AmlSearchContext = createContext<AmlSearchContextValue>({
  lastSearch: undefined,
  setLastSearch: noop as (_values: LastSearch) => void,
});

export const useAmlSearchContext = (): AmlSearchContextValue =>
  useContext(AmlSearchContext);

interface ProviderProps {
  value: AmlSearchContextValue;
  children: React.ReactNode;
}

export const AmlSearchProvider: React.FC<ProviderProps> = ({
  value,
  children,
}) => {
  return (
    <AmlSearchContext.Provider value={value}>
      {children}
    </AmlSearchContext.Provider>
  );
};

export default AmlSearchContext;
